import { defineMessages, useIntl } from 'react-intl';
import React, { useState } from 'react';

const messages = defineMessages({
  step_venue: {
    id: 'step_venue',
    defaultMessage: 'Luogo',
  },
  step_date: {
    id: 'step_date',
    defaultMessage: 'Data e orario',
  },
  step_details: {
    id: 'step_details',
    defaultMessage: 'Dettagli appuntamento',
  },
  step_requestor: {
    id: 'step_requestor',
    defaultMessage: 'Richiedente',
  },
  step_preview: {
    id: 'step_preview',
    defaultMessage: 'Riepilogo',
  },
});

export const prenotazioneSteps = () => {
  const intl = useIntl();

  const STEPS = [
    {
      id: 'stepLuogo',
      label: intl.formatMessage(messages.step_venue),
    },
    {
      id: 'stepData',
      label: intl.formatMessage(messages.step_date),
    },
    {
      id: 'stepDettagli',
      label: intl.formatMessage(messages.step_details),
    },
    {
      id: 'stepRichiedente',
      label: intl.formatMessage(messages.step_requestor),
    },
    {
      id: 'stepRiepilogo',
      label: intl.formatMessage(messages.step_preview),
    },
  ];

  return { STEPS };
};
